import {createClient} from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// ⚠️ SECURITY: never create a service-role client here. Anything in this bundle
// (including REACT_APP_* env vars) ships to every browser. Admin operations
// must go through Supabase Edge Functions, where the service key stays server-side.

if(!supabaseUrl ) {
    throw new Error('Missing Supabase URL');
}
else if(!supabaseAnonKey) {
    throw new Error('Missing anon key ');
}

// ✅ ADD THESE OPTIONS for auto-refresh
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,      // ✅ Automatically refresh tokens
      persistSession: true,         // ✅ Persist session in localStorage
      detectSessionInUrl: true      // ✅ Detect session in URL (for OAuth redirects)
    }
  });

// Dev-only: expose the client for console testing (e.g. simulating session expiry).
if (process.env.NODE_ENV === 'development') {
    window.supabase = supabase;
}
